import LabMenuItems from '../../../module/shop/lab/menu';

const Manage = () => {
  return (
    <div className="mt-4 px-2">
      <LabMenuItems />
    </div>
  );
};

export default Manage;
